"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_EXCEPTION_MESSAGES = {
    getUserById: {
        message: 'Cannot find the user.',
    },
};
